import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'
import SpecTracker from '@/views/specTracker/TrackerIndex'
import Report from '@/views/report/ReportIndex'
import Home from '@/views/Home'
import Welcome from '@/views/Welcome'
import LoginCommon from '@/views/LoginCommon'
import LoginKunMing from '@/views/LoginKunming'
import LoginNanHaiFuYou from '@/views/LoginNanHaiFuYou'
import LoginShengFuYou from '@/views/LoginShengFuYou'
import Error404 from '@/components/error404'

import axios from 'axios';
import VueAxios from 'vue-axios'
import api from '../api'

import store from '../store/index'
import {keyCodes} from '../commons'
import { closeProgress, startProgress } from '../libs/nporgress'

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(api)

const TITLE = '康华查单';

const router =  new Router({
  mode: 'history',
  base: process.env.VUE_APP_WEB_BASE_URL,//对应最终部署的tomcat目录；对应config/index.js下的assetsPublicPath: '/khweb/'
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginCommon,
      meta: {
        title: '登陆'
      },
    },
    {
      path: '/km',
      name: 'loginkm',
      component: LoginKunMing,
      meta: {
        title: '登陆'
      },
    },
    {
      path: '/nhfy',
      name: 'loginnhfy',
      component: LoginNanHaiFuYou,
      meta: {
        title: '登陆'
      },
    },
    {
      path: '/sfy',
      name: 'loginsfy',
      component: LoginShengFuYou,
      meta: {
        title: '登陆'
      },
    },
    {
      path: '/',
      name: '主页',
      component: Home,
      redirect: '/welcome',
      children: [
        {
          path: '/welcome',
          name: '首页',
          components: {
            default: Welcome,
          },
          meta: {requiresAuth: true},
          redirect: '/report',
        },
        {
          path: '/specTracker',
          name: '标本跟踪',
          component: SpecTracker,
          meta: {
            requiresAuth: true,
            title: '标本跟踪'
          },
        },
        {
          path: '/report',
          name: '报告查询',
          component: Report,
          meta: {
            requiresAuth: true,
            title: '报告查询'
          },
        }
      ]
    },
    {
      path: '*',
      component: Error404
    }
  ]
})

router.beforeEach((to, from, next) => {
  startProgress();
  // console.log("beforeEach")
  // if(store.state.routers || store.state.routers.length > 0){
  //   let { routes } = router.options;
  //   let routeData = routes.find(r => r.path === '/');
  //
  //   $.merge(routeData.children,store.state.routers);
  //   $.unique(routeData.children);
  //
  //   router.addRoutes([routeData]);
  // }

  if (to.meta.title) {
    document.title = TITLE + '-' + to.meta.title
  }
  else{
    document.title = TITLE;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    const userInfo = store.state.userInfo;
    if (!userInfo || userInfo.is_first_signin != 1) {
      let toPath = '/login';
      if(store.state.loginBy == keyCodes.LOGIN_BY_KM){
        toPath = '/km';
      }
      else if(store.state.loginBy == keyCodes.LOGIN_BY_NHFY){
        toPath = '/nhfy';
      }
      next({
        path: toPath,
        query: {redirect: to.fullPath}
      })
    }
    else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
})

// router.onReady(()=>{
//   console.log("on ready")
// });

// router.afterEach((to,from)=>{
//   window.localStorage.curRouter = JSON.stringify({path: to.path,component: c.componentName});
//   let c = '';
//
// })
router.afterEach(() => {
  closeProgress();
})

router.onError(()=>{

})

export default router;

//var getLastUrl=(str,yourStr)=>str.slice(str.lastIndexOf(yourStr))//取到浏览器出现网址的最后"/"出现的后边的字符



// WEBPACK FOOTER //
// ./src/router/index.js